import {Component, input} from '@angular/core'
import {IMessage} from '../../services/message.service'
import {DatePipe} from '@angular/common'
import {MatDivider} from '@angular/material/divider'
import {MatAnchor} from '@angular/material/button'
import {RouterLink} from '@angular/router'
import {MatIcon} from '@angular/material/icon'

@Component({
  selector: 'spb-list-item',
  imports: [
    DatePipe,
    MatAnchor,
    MatDivider,
    RouterLink,
    MatIcon
  ],
  templateUrl: './list-item.component.html',
  styleUrl: './list-item.component.scss'
})
export class ListItemComponent {
  public message = input.required<IMessage>()
}
